import { Chip, IconButton } from "@material-ui/core";
import { Done, Home, NavigateBefore, NavigateNext } from "@material-ui/icons";
import moment from "moment";
import React from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import "../../constants/Styles/index.css";

const CarrouselChips = ({ selectedSchedule, groups, onChipselected, savedSchedule }) => {
  return (
    <div style={{ width: "108%", marginRight: -15, marginLeft: -15 }}>
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
        {groups.map((e, i) => (
          <MyChip key={i} selectedSchedule={selectedSchedule} onChipselected={onChipselected} savedSchedule={savedSchedule} i={i} e={e} />
        ))}
      </ScrollMenu>
    </div>
  );
};

const MyChip = ({ selectedSchedule, onChipselected, savedSchedule, i, e, onClick }) => {
  const visibility = React.useContext(VisibilityContext);
  const visible = visibility.isItemVisible(i);
  return (
    <Chip
      itemId={i}
      color={selectedSchedule == i ? "primary" : "default"}
      label={moment(e.time).format("dddd DD MMM · HH:mm")}
      onDelete={() => onChipselected(i)}
      style={{ display: e.remaining > 0 || savedSchedule == i ? "inherit" : "none", padding: savedSchedule !== i && 7, marginLeft: 6 }}
      deleteIcon={savedSchedule == i ? <Done color="white" /> : <></>}
      onClick={() => onChipselected(i)}
    />
  );
};

export default CarrouselChips;

function Arrow({ children, disabled, onClick }) {
  return (
    <IconButton
      disabled={disabled}
      onClick={onClick}
      size="small"
      style={{
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        opacity: disabled ? "0" : "1",
        userSelect: "none",
      }}
    >
      {children}
    </IconButton>
  );
}

export function LeftArrow() {
  const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators, initComplete } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(!initComplete || (initComplete && isFirstItemVisible));
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollPrev()}>
      <NavigateBefore />
    </Arrow>
  );
}

export function RightArrow() {
  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } = React.useContext(VisibilityContext);

  // console.log({ isLastItemVisible });
  const [disabled, setDisabled] = React.useState(!visibleItemsWithoutSeparators.length && isLastItemVisible);
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollNext()}>
      <NavigateNext />
    </Arrow>
  );
}
